import styled from 'styled-components'

export const StyledMobileMenuUtility = styled.ul`
  width: auto;
  padding: 0;
  list-style-type: none;
  margin: ${props => props.theme.typography.pxToRem(20)} 0;
`